/**
 * Chaves das feature flags no ConfigCat, e o valor que vale quando ele não respondeu.
 *
 * Os defaults são FAIL-OPEN de propósito: sem resposta do ConfigCat — CDN fora do ar, rede
 * corporativa bloqueando, primeiro acesso sem cache — o app funciona como se a flag estivesse
 * ligada. O estado normal destas flags é ligado e o desligamento é excepcional, então a
 * indisponibilidade de um SaaS não pode derrubar uma ação central do produto.
 *
 * Quem adicionar uma flag cujo default seguro seja `false` precisa pensar no caso oposto: o app
 * passa a depender do ConfigCat estar no ar para a funcionalidade existir.
 */
export const FeatureFlags = {
	/** Botão "Nova ocorrência" na aba de ocorrências do contrato. */
	OccurrenceCreation: 'isOccurrenceCreationEnabled',

	/**
	 * Piloto do Seguro Fiança (multicálculo). Default FAIL-CLOSED de propósito, ao contrário
	 * das demais: produto novo em piloto não pode aparecer para todo mundo só porque o
	 * ConfigCat ficou fora do ar.
	 */
	SuretyInsurance: 'isSuretyInsuranceEnabled',
} as const;

export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export const FeatureFlagDefaults: Record<string, boolean> = {
	[FeatureFlags.OccurrenceCreation]: true,
	[FeatureFlags.SuretyInsurance]: false,
};
